
let ventas = [
  { id: "3", name: "Entrega" }, 
];

let produccion = [
  { id: "2", name: "Control Tiempos Muertos" },
];

let compras = [
  { id: "1001", name: "Solicitud de compras servicio" }, 
  { id: "1002", name: "Solicitud de compras" }, 
];

let autorizaciones = [
  { id: "2001", name: "Autorizaciones Compras" }, 
];

let logistica = [
  { id: "3001", name: "Logistica" }, 
  { id: "3002", name: "Autorizar OTs" }, 
  { id: "3003", name: "Despacho Combustible" }, 
  { id: "3004", name: "Control de Combustible Externos Cartelera" }, 
  { id: "3005", name: "Control de Combustible Externos Facturacion" }, 
  { id: "3006", name: "Ingresar Factura FFACSA" }, 
];





module.exports = {
 
  ventas,  
 
  produccion,  
  
  compras, 

  autorizaciones,

  logistica
};
